import { callKarrotBridgeSafely } from "../../../lib/karrot_bridge_utils"

const NETWORK_ERROR_MESSAGE = '네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'

export function isAbortError(error) {
  if (!error) {
    return false
  }

  const code = error.code
  const name = error.name
  const message = typeof error.message === 'string' ? error.message : ''

  return (
    code === 'ECONNABORTED' ||
    code === 'ERR_CANCELED' ||
    name === 'CanceledError' ||
    name === 'AbortError' ||
    message === 'Request aborted' ||
    message === 'The user aborted a request'
  )
}

export function isNetworkError(error) {
  if (!error) {
    return false
  }

  const message = typeof error.message === 'string' ? error.message : ''
  return message.includes('Network Error') || message.includes('Failed to fetch')
}

export function notifyNetworkError(message = NETWORK_ERROR_MESSAGE) {
  if (typeof window === 'undefined') {
    return false
  }

  return callKarrotBridgeSafely(
    (bridge) => bridge.openToast({
      toast: {
        body: message,
        type: 'SNACKBAR'
      }
    }),
    { fallback: () => alert(message) }
  )
}
